import React, {Fragment, useState, useEffect} from "react";

import MisuseReportTable from "root/Tables/MisuseReportTable";
import './SafeguardingTab.scss';
import {getMisuseReports} from "root/DataFunctions/SafeguardingDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import useModalAddMisuseReport from "root/Modals/AddMisuseReport/useModalAddMisuseReport";

const SafeguardingTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const [renderAddMisuseReportModal, showAddMisuseReportModal] = useModalAddMisuseReport((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        getMisuseReports( (response) =>
        {
            const data = getDataFromResponse( response ) ;
            setData({ isLoading: false, data: data});
        });
    }

    const clickHandler = (mode, misuse_report_id) =>
    {
        showAddMisuseReportModal(mode, misuse_report_id);
    }

    return (
        <Fragment>
            <div className="family-body">
                <MisuseReportTable loading={data.loading} data={data.data} clickHandler={clickHandler}/>
            </div>

            {renderAddMisuseReportModal(props)}
        </Fragment>
    )
}

SafeguardingTab.defaultProps = {};

export default SafeguardingTab;

